import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { FilterProvider } from './context/FilterContext';
import Header from './components/Common/Header';
import Footer from './components/Common/Footer';
import UeberUns from './pages/UeberUns';
import HomePage from './pages/HomePage';
import ActivityDetail from './pages/ActivityDetail';
import ActivityControl from './pages/ActivityControl';
import MyActivities from './pages/MyActivities';
import AddActivity from './pages/AddActivityPage';
import Impressum from './pages/Impressum';
import Datenschutz from './pages/Datenschutz';
import Aufnahmeregeln from './pages/Aufnahmeregeln';
import ZeitangabenFormate from './pages/ZeitangabenFormate';
import EmailVerify from './pages/EmailVerify';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import MobileLoginPage from './pages/MobileLoginPage';
import CookieConsent from './components/Common/CookieConsent';
import WelcomeModal from './components/Common/WelcomeModal';

// Layout-Komponente für Seiten mit Header/Footer
const LayoutWithHeaderFooter = ({ children }) => (
  <>
    <Header />
    <main>{children}</main>
    <Footer />
  </>
);

function App() {
  return (
    <Router future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
      <AuthProvider>
        <FilterProvider>
          <div className="app">
            <WelcomeModal />
            <CookieConsent />
            <Routes>
              {/* Home-Seite (Aktivitäten-Übersicht mit eigenem Header) */}
              <Route path="/" element={<LayoutWithHeaderFooter><HomePage /></LayoutWithHeaderFooter>} />

              {/* Aktivitäten-Seite (alias) */}
              <Route path="/aktivitaeten" element={<LayoutWithHeaderFooter><HomePage /></LayoutWithHeaderFooter>} />

              {/* "Über uns" mit Header/Footer */}
              <Route path="/ueber-uns" element={<LayoutWithHeaderFooter><UeberUns /></LayoutWithHeaderFooter>} />
              
              {/* Impressum und Datenschutz mit Header/Footer */}
              <Route path="/impressum" element={<LayoutWithHeaderFooter><Impressum /></LayoutWithHeaderFooter>} />
              <Route path="/datenschutz" element={<LayoutWithHeaderFooter><Datenschutz /></LayoutWithHeaderFooter>} />
              <Route path="/aufnahmeregeln" element={<LayoutWithHeaderFooter><Aufnahmeregeln /></LayoutWithHeaderFooter>} />
              <Route path="/zeitangaben-formate" element={<LayoutWithHeaderFooter><ZeitangabenFormate /></LayoutWithHeaderFooter>} />
              
              {/* Add Activity mit Header/Footer */}
              <Route path="/activities/new" element={<LayoutWithHeaderFooter><AddActivity /></LayoutWithHeaderFooter>} />
              
              {/* Alle anderen Routen mit Header/Footer */}
              <Route path="/activities/:id" element={<LayoutWithHeaderFooter><ActivityDetail /></LayoutWithHeaderFooter>} />
              <Route path="/aktivitaet-kontrolle/:id" element={<LayoutWithHeaderFooter><ActivityControl /></LayoutWithHeaderFooter>} />
              <Route path="/meine-aktivitaeten" element={<LayoutWithHeaderFooter><MyActivities /></LayoutWithHeaderFooter>} />
              <Route path="/email-bestaetigen" element={<EmailVerify />} />
              <Route path="/passwort-vergessen" element={<ForgotPassword />} />
              <Route path="/passwort-zuruecksetzen" element={<ResetPassword />} />
              <Route path="/anmelden" element={<MobileLoginPage />} />
            </Routes>
          </div>
        </FilterProvider>
      </AuthProvider>
    </Router>
  );
}

export default App;
